import { useAuthStore } from '@/modules/auth/store/auth.store'
import { usePermissionsStore } from '@/modules/auth/store/permissions.store'
import { initializeSession } from '@/modules/auth/services/session.service'
import { hasAnyRole } from '@/shared/lib/access'

export function canAccessRoute(route, authStore, permissionsStore) {
    if (route.meta.requiresAuth && !authStore.user) {
        return false
    }

    if (
        route.meta.permissions?.length &&
        !permissionsStore.hasAnyPermission(route.meta.permissions)
    ) {
        return false
    }

    if (
        route.meta.roles?.length &&
        !hasAnyRole(authStore.user, route.meta.roles)
    ) {
        return false
    }

    return true
}

export function setupRouterGuards(router) {
    router.beforeEach(async (to) => {
        await initializeSession()

        const authStore = useAuthStore()
        const permissionsStore = usePermissionsStore()

        if (!canAccessRoute(to, authStore, permissionsStore)) {
            return '/home'
        }
    })
}
